export default { 
  name : 'product.event.subtype',
  objectType : 'product.event',
  valueType : 'string',
  displayName : 'Subtype',
  get : ( obj, cxt ) => {
    return obj?.data.subtype
  }
}
